import { h } from 'preact';

export const PlaneIcon = () => {
	return (
		<svg width="17" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip3)">
				<path
					d="M15 4.13L1 12.21A1 1 0 001.12 14l4.38 1.81V19a1 1 0 001.77.63l1.9-2.3 3.95 1.63a1 1 0 001.37-.77l2-13.04A1 1 0 0015 4.13zM6.5 19v-2.77l1.7.7L6.5 19zm7-.97l-6.44-2.66L13.29 8c.15-.17-.09-.4-.26-.26l-7.98 6.8-3.55-1.46L15.5 5l-2 13.03z"
					fill="currentColor"/>
			</g>
			<defs>
				<clipPath id="clip3">
					<path fill="currentColor" transform="translate(.5)" d="M0 0h16v24H0z"/>
				</clipPath>
			</defs>
		</svg>
	);
};
